import actionCreator from '@/helpers/redux/actionCreator';

export const SUBMIT_FORM_REQUEST = '@/SUBMIT_FORM_REQUEST';
export const SUBMIT_FORM_RESPONSE = '@/SUBMIT_FORM_RESPONSE';
export const SUBMIT_FORM_RESPONSE_FAIL = '@/SUBMIT_FORM_RESPONSE_FAIL';
export const NEXT_FORM_STAGE = '@/NEXT_FORM_STAGE';
export const CANCEL_SUBMIT_FORM = '@/CANCEL_SUBMIT_FORM';
export const SAVE_FORMIK_VALUES = '@/SAVE_FORMIK_VALUES';

export const saveFormikValues = formikValues => actionCreator(SAVE_FORMIK_VALUES, { formikValues });

export const submitFormRequest = ({
  formData, configuration, redirectUrl, userId,
}) => actionCreator(
  SUBMIT_FORM_REQUEST,
  { formData, configuration },
  { redirectUrl, userId },
);

export const submitFormResponse = data => actionCreator(
  SUBMIT_FORM_RESPONSE,
  { data },
);

export const submitFormResponseFail = error => actionCreator(
  SUBMIT_FORM_RESPONSE_FAIL,
  { error },
);

export const nextFormStageSetter = () => actionCreator(
  NEXT_FORM_STAGE,
);

export const cancelSubmit = redirectUrl => actionCreator(
  CANCEL_SUBMIT_FORM,
  { redirectUrl },
);
